export const CHECK_AUTH = "checkAuth";
export const LOGIN = "login";
export const REFRESH_TOKEN = "refreshToken";
export const LOGOUT = "logout";
export const SET_ERRORS = "errors";
